<template>
  <div></div>
</template>

<script>

import L from 'leaflet';
import { mapGetters } from 'vuex';
import EventBus from '@/events/event-bus';

export default {
  name: 'DrawPoint',
  props: {
    map: {
      type: Object,
      required: true,
    },
    mode: {
      type: String,
      required: true,
    },
    map_object_type_id: {
      type: Number,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      keyValues: 'settings/getKeyValues',
      mapObject: 'selected/getMapObject',
    }),
  },
  data() {
    return {
      marker: null,
    };
  },
  methods: {
    mapClick(e) {
      const { lat, lng } = e.latlng;
      this.updateMarker(lat, lng);
    },
    updateMarker(lat, lng) {
      if (this.marker !== null) {
        this.map.removeLayer(this.marker);
      }

      EventBus.$emit('Map.shareCoordinates', [lng, lat]);
      const marker = new L.Marker([lat, lng]);
      marker.map_object_type_id = this.map_object_type_id;
      // eslint-disable-next-line max-len

      const iconValue = this.getIcon(this.map_object_type_id).value;
      const label = (this.mode === 'objectUpdate' && this.mapObject ? this.$options.filters.mapObjectLabel(this.mapObject) : '');
      const icon = this.getIconByMapObjectType(iconValue, 0, label, true);
      marker.setIcon(icon);
      this.marker = marker;
      marker.addTo(this.map);
    },
    getIcon(typeId) {
      let icon = this.keyValues.filter(
        u => u.key === `map_object_type_icon_${typeId}`,
      );
      if (icon.length > 0) {
        // eslint-disable-next-line prefer-destructuring
        icon = icon[0];
      } else {
        icon = {};
      }
      return icon;
    },
  },
  mounted() {
    this.map.off('click');
    this.map.on('click', (e) => {
      this.mapClick(e);
    });
    EventBus.$off('Map.createObjectReset');
    EventBus.$on('Map.createObjectReset', () => {
      this.map.removeLayer(this.marker);
      this.marker = null;
    });

    EventBus.$off('Map.updateCoordinates');
    EventBus.$on('Map.updateCoordinates', (coordinates) => {
      this.updateMarker(coordinates[1], coordinates[0]);
    });
    // set coordinates from mapObject if we move the object, but not if we're creating a child
    if (this.mode === 'objectUpdate' && this.mapObject && this.mapObject.map_object_type_id === this.map_object_type_id) {
      const coordinates = this.getCoordinates(this.mapObject, 'point');
      this.mapClick({ latlng: { lat: coordinates[0], lng: coordinates[1] } });
    }
  },
  beforeDestroy() {
    if (this.marker) {
      this.map.removeLayer(this.marker);
    }
    EventBus.$off('Map.createObjectReset');
  },
};
</script>

<style scoped>

</style>
